<template>
  <ion-footer v-if="nextPickupIndex !== -1" class="ion-no-border">
    <ion-toolbar class="journey-overview">
      <div class="ion-text-center">
        <div class="first-line">
          {{ command }}
          <span class="time">
            {{ time }}h
            <span v-if="hasDelay" class="delay" :class="{ over5: isDelayOver5Minutes }">{{ delay }}</span>
          </span>
          {{ station }}
        </div>
        <div class="second-line"></div>
      </div>
    </ion-toolbar>
  </ion-footer>
</template>

<script setup lang="ts">
import { IonFooter, IonToolbar } from '@ionic/vue';
import useAbholungBegleitungCoreData from '@/composables/abholung-begleitung/useAbholungBegleitungCoreData.ts';
import useAbholungBegleitungTexts from '@/composables/abholung-begleitung/useAbholungBegleitungTexts.ts';

const { currentTime, nextPickup, nextPickupIndex } = useAbholungBegleitungCoreData();

const { command, delay, hasDelay, isDelayOver5Minutes, station, time } = useAbholungBegleitungTexts(
  currentTime,
  nextPickup,
);
</script>

<style scoped lang="scss">
@use '@/theme/dbStyle';

.journey-overview {
  --background: #{dbStyle.color('cool-gray', 800)};
  --color: #{dbStyle.color('cool-gray', 100)};

  font-weight: bold;

  .delay {
    color: dbStyle.$puenktlich;
    &.over5 {
      color: dbStyle.$verspaetet;
    }
  }
}
</style>
